<template>
  <Page title="Members">
    <TabSwitcher
      v-if="customerData && addressData"
      id="members"
      :tabs="tabs"
      @tab-change="onTabChange"
    />
  </Page>
</template>

<script lang="ts" setup>
import { computed, onMounted, ref } from "vue";
import { trackEvent } from "@/lib/pendo";

import Page from "@/components/Page.vue";
import TabSwitcher from "@/components/TabSwitcher/TabSwitcher.vue";
import Members from "./Members.vue";
import MembersByAddress from "./MembersByAddress.vue";

const BY_ADDRESS_TAB = "By Address";

type InitialPageData = {
  source: string;
  filters: unknown[];
};

const customerData = ref<InitialPageData | null>(null);
const addressData = ref<InitialPageData | null>(null);

const tabs = computed(() => [
  {
    name: "By Program",
    component: Members,
    props: customerData.value
  },
  {
    name: "By Address",
    component: MembersByAddress,
    props: addressData.value
  }
]);

async function loadJson(path: string): Promise<InitialPageData> {
  const url = `${window.location.origin}${path}`;
  const res = await fetch(url, {
    method: "GET",
    headers: { Accept: "application/json" }
  });
  return res.json();
}

function onTabChange(tabName: string): void {
  if (tabName === BY_ADDRESS_TAB) {
    trackEvent("members_report_by_address_tab_viewed");
  }
}

onMounted(async () => {
  const customerPromise = loadJson("/reports/members/initial_page_data");
  const addressPromise = loadJson(
    "/reports/members_by_address/initial_page_data"
  );

  const [customer, address] = await Promise.all([
    customerPromise,
    addressPromise
  ]);
  customerData.value = customer;
  addressData.value = address;
});
</script>
